export enum AccountFileCategoryEnum {
  PASSPORT_SCAN = 'PASSPORT_SCAN',
}
